import Swiper, { Navigation, Scrollbar, EffectFade, Thumbs, Lazy } from 'swiper'
Swiper.use([Navigation, Scrollbar, Thumbs, EffectFade, Lazy])

export default class HistorySlider {

  constructor (el) {
    this.el = el
    this.contentSlider = null
    this.yearsSlider = null
    this.content = this.el.querySelector('.js-history-slider-content')
    this.years = this.el.querySelector('.js-history-slider-years')
    this.slides = this.years.querySelectorAll('.swiper-slide')
    this.dragBar = null
    this.isAnimated = false
    this.firstSlideChange = true
  }

  init () {
    this.initSLider()
    this.onInView()
    this.initEvents()
  }

  initEvents () {
    window.addEventListener('resize', () => this.onInView())
    window.addEventListener('scroll', () => this.onInView())
    this.slides.forEach(el => {
      el.addEventListener('click', e => this.onYearClick(e))
    })
  }

  onYearClick (e) {
    const index = $(e.currentTarget).index()
    this.yearsSlider.slideTo(index, 300)
  }

  onInView () {
    if (this.isAnimated) return;
    if (!this.el.getAttribute('data-animated')) return;

    this.yearsSlider.slideTo(0, 1200)
    this.isAnimated = true
    setTimeout(() => {
      this.content.classList.add('active')
      this.contentSlider.slideTo(0, 0)
      this.firstSlideChange = false
    }, 1000)
  }

  initSLider () {
    const targetSlideIndex = Math.floor(this.slides.length / 2)

    this.yearsSlider = new Swiper(this.years, {
      slidesPerView: 'auto',
      centeredSlides: true,
      simulateTouch: false,
      initialSlide: targetSlideIndex,
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: 52
      },
      on: {
        scrollbarDragEnd: () => {
          if (this.firstSlideChange) return;
          const index = this.yearsSlider.realIndex
          this.contentSlider.slideTo(index)
        },
        activeIndexChange: () => {
          if (this.firstSlideChange) return;
          const index = this.yearsSlider.realIndex
          this.contentSlider.slideTo(index)
        }
      }
    })

    this.contentSlider = new Swiper(this.content, {
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadOnTransitionStart: true
      },
      slidesPerView: 1,
      effect: 'fade',
      autoHeight: true,
      centeredSlides: true,
      followFinger: false,
      simulateTouch: false,
      allowTouchMove: false,
      initialSlide: targetSlideIndex
    })

  }
 
}